<div id="doctor-view" class="page-layout blank">

    <div class="content">

        <div class="left">

            <div *ngIf="this.headerService.isLoading == false" fxLayout="column" fxLayoutAlign="start"
                fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">

                <!-- Widget appointments -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="30">
                    <app-appointments></app-appointments>
                </div>
                <!-- / Widget appointments -->

                <!-- Widget tasks -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="70">
                    <app-tasks></app-tasks>
                </div>
                <!-- / Widget tasks --> 

                <!-- Widget stat-count -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="20">
                    <app-stat-count></app-stat-count>
                </div>
                <!-- / Widget stat-count -->

            </div>
            <div class="spinner-load m-auto" *ngIf="this.headerService.isLoading == true">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
        </div>

    </div>

</div>